import {
  useEffect,
} from 'react';
import { useLocation } from 'react-router';
import { env } from 'constants';
import usePersistedState from './usePersistedState';

function useHomePath() {
  const [home, setHome] = usePersistedState('/', 'use-home-path/home');

  return '/';
}

export default useHomePath;
